export const DEFAULT_SHIP_TYPE = 'O'
export const DEFAULT_CST = 'O,V'
export const DEFAULT_BRAND = 'C,R'

export const VOYAGE_TYPES = [
  {
    label: 'All Types',
    value: 'O,V',
    filter: 'O,V',
    brands: ['C', 'R', 'C,R'],
    brand: 'C,R'
  },
  {
    label: 'Ocean',
    value: 'O',
    filter: 'O',
    brands: ['C', 'R', 'C,R'],
    brand: 'C,R'
  },
  {
    label: 'River',
    value: 'V',
    filter: 'V',
    brands: ['C', 'C,R'],
    brand: 'C'
  }
]

export const BRAND_NARROW_RESUTLS = [
  {
    label: 'Royal Caribbean',
    brand: 'R',
    types: ['O,V', 'O']
  },
  {
    label: 'Celebrity',
    brand: 'C',
    types: ['O,V', 'O', 'V']
  }
]

export const PRICE_ALL_VOYAGE_OPTIONS = [
  {
    key: 'voyage-type-all',
    label: 'All Types',
    value: 'O,V',
    brands: ['C', 'R']
  },
  {
    key: 'voyage-type-ocean',
    label: 'Ocean',
    value: 'O',
    brands: ['C', 'R']
  },
  {
    key: 'voyage-type-river',
    label: 'River',
    value: 'V',
    brands: ['C']
  }
]

export const PRICE_VOYAGE_OPTIONS = [
  {
    key: 'voyage-type-ocean',
    label: 'Ocean',
    value: 'O'
  },
  {
    key: 'voyage-type-river',
    label: 'River',
    value: 'V'
  }
]

export const VOYAGE_TYPE = { O: 'Ocean', V: 'River' }

export const RIVER_SHIP_CODES = ['RC', 'RS']
